import { render, staticRenderFns } from "./LightHeader.vue?vue&type=template&id=8c8a7f3c&scoped=true&"
import script from "./LightHeader.vue?vue&type=script&lang=js&"
export * from "./LightHeader.vue?vue&type=script&lang=js&"
import style0 from "./LightHeader.vue?vue&type=style&index=0&id=8c8a7f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8a7f3c",
  null
  
)

export default component.exports